import { Button, TextField, XStack, YStack } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

import { DesignSystem } from '../../../../../../../../../../../../../../enums/designSystem'
import { useFormContext } from '../../../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema } from '../../../../../../types/supplierForm'

interface AdditionalContactFieldsProps {
  index: number
  onDeleteClick: () => void
}

export const AdditionalContactFields = ({ index, onDeleteClick }: AdditionalContactFieldsProps) => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema, DesignSystem.Lumen>({ designSystem: DesignSystem.Lumen })

  return (
    <YStack gap={24}>
      <FormItem
        name={`additionalContactPersons.${index}.firstName`}
        render={({ error, field }) => (
          <TextField {...field} error={error} label={t('suppliers.detail.form.first_name.label')} size="small" />
        )}
      />
      <FormItem
        name={`additionalContactPersons.${index}.lastName`}
        render={({ error, field }) => (
          <TextField {...field} error={error} label={t('suppliers.detail.form.last_name.label')} size="small" />
        )}
      />
      <FormItem
        name={`additionalContactPersons.${index}.email`}
        render={({ error, field }) => (
          <TextField
            {...field}
            error={error}
            label={t('suppliers.detail.form.email.label')}
            placeholder={t('suppliers.detail.form.email.placeholder')}
            size="small"
            type="email"
          />
        )}
      />
      <XStack>
        <Button
          color="danger"
          label={t('contact.detail.contact_persons.actions.delete')}
          onClick={onDeleteClick}
          size="small"
          variant="text"
        />
      </XStack>
    </YStack>
  )
}
